<nz-card>
  <div class="search-section">
    <div nz-row [nzGutter]="16" nzJustify="end" nzAlign="middle">
      <div nz-col [nzSpan]="12">
        <nz-input-group nzSearch [nzSuffix]="suffixIconSearch">
          <input
            type="text"
            nz-input
            placeholder="Search by model name, seed audience, lookalike name or owner"
            [(ngModel)]="searchValue"
            (ngModelChange)="onSearch()"
          />
        </nz-input-group>
        <ng-template #suffixIconSearch>
          <span nz-icon nzType="search"></span>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="model-history-table table-content">
    <nz-table
      #nestedTable
      [nzData]="filteredData"
      nzTableLayout="fixed"
      nzShowPagination
      nzShowSizeChanger
      [nzLoading]="isLoading"
      [nzTotal]="totalCount!"
      [nzPageSizeOptions]="supportedPageSizes"
      [nzNoResult]="emptyTemplate"
      [nzVirtualItemSize]="11"
      [nzScroll]="{ y: 'calc(100vh - 25rem)' }"
    >
      <thead>
        <tr>
          <th
            *ngFor="let header of headers"
            [nzWidth]="header.width"
            [nzSortOrder]="header.sortOrder"
            [nzSortFn]="header.sortFn"
            [nzSortDirections]="header.sortDirections"
            [nzFilters]="header.listOfFilter"
            [nzFilterFn]="header.filterFn"
            [nzFilterMultiple]="header.filterMultiple"
            [nzRight]="header.right"
          >
            {{ header.name }}
          </th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let model of nestedTable.data">
          <tr>
            <td [(nzExpand)]="model.expand"></td>
            <td nzEllipsis [nz-tooltip]="model.name">
              {{ model.name }}
            </td>
            <td nzEllipsis [nz-tooltip]="model.modelId">
              {{ model.modelId }}
            </td>
            <td nzEllipsis [nz-tooltip]="model.queryName">{{ model.queryName }}</td>
            <td>{{ formatNumber(model.seedAudienceSize ?? null) }}</td>
            <td>{{ model.createdBy || '--' }}</td>
            <td>
              <nz-tag [nzColor]="getStatusColor(model.status)">{{ getStatusDisplayName(model.status) }}</nz-tag>
            </td>
            <td>{{ model.lastModifiedAt | dateTime }}</td>
            <td nzRight>
              <button
                nz-button
                nz-dropdown
                [nzDropdownMenu]="modelActionMenu"
                [disabled]="!appService.isEngagementActive"
                nz-tooltip
                [nzTooltipTitle]="!appService.isEngagementActive ? 'Engagement is not active' : ''"
              >
                <span nz-icon nzType="more"></span>
              </button>
              <nz-dropdown-menu #modelActionMenu="nzDropdownMenu">
                <ul nz-menu *ngIf="appService.isEngagementActive">
                  <li nz-menu-item (click)="onModelAction('view', model)" *ngIf="model?.status !== 'IN_PROGRESS'">
                    <span nz-icon nzType="eye" nzTheme="outline" *ngIf="model?.status === 'FAIL'"></span>
                    <span nz-icon nzType="plus" nzTheme="outline" *ngIf="model?.status === 'SUCCESS'"></span>
                    {{ model?.status === 'FAIL' ? 'View' : 'Create Lookalike' }}
                  </li>
                  <li
                    nz-menu-item
                    (click)="canDeleteModel(model) && onModelAction('delete', model)"
                    class="delete-action"
                    [nzDisabled]="!canDeleteModel(model)"
                    [nz-tooltip]="
                      !canDeleteModel(model)
                        ? 'The base model cannot be deleted while it has associated lookalike audiences or an in-progress model.'
                        : ''
                    "
                    nzTooltipPlacement="left"
                  >
                    <span nz-icon nzType="delete" nzTheme="outline"></span>
                    Delete
                  </li>
                </ul>
              </nz-dropdown-menu>
            </td>
          </tr>
          <tr [nzExpand]="model.expand">
            <nz-table
              #innerTable
              [nzData]="model.lookalikeAudiences"
              nzSize="middle"
              [nzShowPagination]="false"
              nzTableLayout="fixed"
              [nzScroll]="{ x: '100rem' }"
            >
              <thead>
                <tr>
                  <th width="20%">Lookalike Name</th>
                  <th width="20%">Lookalike ID</th>
                  <th width="8%">Lookalike Size</th>
                  <th width="12%">Owner</th>
                  <th width="10%">Status</th>
                  <th width="18%">Last Modified At</th>
                  <th width="5%" nzRight>Action</th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let lookalike of model.lookalikeAudiences">
                  <tr>
                    <td nzEllipsis [nz-tooltip]="lookalike.name">
                      {{ lookalike.name }}
                    </td>
                    <td nzEllipsis [nz-tooltip]="lookalike.modelId">
                      {{ lookalike.modelId }}
                    </td>
                    <td>{{ formatNumber(lookalike.lookalikeNumber ?? null) }}</td>
                    <td>{{ lookalike.createdBy || '--' }}</td>
                    <td>
                      <nz-tag [nzColor]="getStatusColor(lookalike.status)">{{
                        getStatusDisplayName(lookalike.status)
                      }}</nz-tag>
                    </td>
                    <td>{{ lookalike.lastModifiedAt | dateTime }}</td>
                    <td nzRight>
                      <button nz-button nz-dropdown [nzDropdownMenu]="lookalikeActionMenu">
                        <span nz-icon nzType="more"></span>
                      </button>
                      <nz-dropdown-menu #lookalikeActionMenu="nzDropdownMenu">
                        <ul nz-menu>
                          <li
                            nz-menu-item
                            (click)="onLookalikeAction('view', lookalike)"
                            *ngIf="lookalike?.status !== 'IN_PROGRESS'"
                          >
                            <span nz-icon nzType="eye" nzTheme="outline"></span>
                            View
                          </li>
                          <li
                            nz-menu-item
                            (click)="canDeleteLookalike(lookalike) && onLookalikeAction('delete', lookalike)"
                            class="delete-action"
                            [nzDisabled]="!canDeleteLookalike(lookalike)"
                            [nz-tooltip]="
                              !canDeleteLookalike(lookalike)
                                ? 'The lookalike cannot be deleted as it is currently in progress.'
                                : ''
                            "
                            nzTooltipPlacement="left"
                            *ngIf="appService.isEngagementActive"
                          >
                            <span nz-icon nzType="delete" nzTheme="outline"></span>
                            Delete
                          </li>
                        </ul>
                      </nz-dropdown-menu>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </nz-table>
          </tr>
        </ng-container>
      </tbody>
    </nz-table>

    <ng-template #emptyTemplate>
      <nz-empty [nzNotFoundImage]="'simple'" [nzNotFoundContent]="emptyContent"> </nz-empty>
      <ng-template #emptyContent>
        <span *ngIf="searchValue; else noModelsTemplate"> No models found matching "{{ searchValue }}" </span>
        <ng-template #noModelsTemplate> No data available. </ng-template>
      </ng-template>
    </ng-template>
  </div>
</nz-card>
